import { render } from "./IconRecipient.vue?vue&type=template&id=4871e4b4"
const script = {}
script.render = render

export default script